module.exports = __webpack_public_path__ + "static/img/sjds.d39778a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjds.png
// module id = 7Bg2
// module chunks = 0